import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { FaLocationArrow } from 'react-icons/fa';
import { IconEye, IconEyeOff } from '@tabler/icons';
import { toast } from 'react-toastify';
import { sendData } from '../../redux/actions/api/SendData';
import Breadcrumb from '../../components/breadcrumb/Breadcrumb';
import Loading from '../../components/loading/Loading';
import {
  checkComplicityPassword,
  checkValidationPhone,
} from '../../utils/function';
import { toggleShowingPassword } from '../../utils/function/toggleShowingPassword';

export default function NewAdmin() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isShowPassword, setIsShowPassword] = useState(false);
  const [isShowPasswordConfirm, setIsShowPasswordConfirm] = useState(false);
  const { accessToken } = useSelector((state) => state.auth);
  const { loading, error } = useSelector((state) => state.api);
  // ----------------------------------------------------------------------------------->
  useEffect(() => {
    error && toast.error(error);
  }, [dispatch, error, loading]);
  // ----------------------------------------------------------------------------------->
  const initialValues = {
    // initial Values input felids
    name: '',
    email: '',
    phone: '',
    role: '',
    password: '',
    passwordConfirm: '',
  };
  // ----------------------------------------------------------------------------------->
  const validationSchema = Yup.object({
    // validation and check input is not empty
    name: Yup.string()
      .required(`name required`)
      .min(3, `The name you should not be less than 3 characters`)
      .max(30, `The name you must not than 30 characters`),
    email: Yup.string()
      .required(`email required`)
      .min(6, `The email you should not be less than 6 characters`)
      .max(40, `The email you must not than 40 characters`)
      .email('Invalid email format'),
    phone: Yup.string()
      .required(`phone required`)
      .min(10, `The phone you should not be less than 10 characters`)
      .max(12, `The phone you must not than 12 characters`),
    role: Yup.string().required(`role required`),
    password: Yup.string()
      .required(`password required`)
      .min(6, `The password you should not be less than 6 characters`)
      .max(30, `The password you must not than 30 characters`)
      .matches(
        checkComplicityPassword,
        'New password does not meet complexity requirements'
      ),
    passwordConfirm: Yup.string()
      .required(`password confirm required`)
      .min(6, `The password confirm you should not be less than 6 characters`)
      .max(30, `The password confirm you must not than 30 characters`)
      .oneOf(
        [Yup.ref('password'), null],
        'password confirm do not match equals'
      ),
  });
  // ----------------------------------------------------------------------------------->
  const onSubmit = (values) => {
    // handel to modify admin
    const data = {
      name: values?.name,
      email: values?.email,
      phone: values?.phone,
      role: values?.role,
      password: values?.password,
      password_confirmation: values?.passwordConfirm,
    };
    dispatch(sendData(`admins`, accessToken, data, navigate, '/admins'));
  };
  const formik = useFormik({
    initialValues,
    onSubmit,
    validationSchema,
  });
  return (
    <>
      <Loading isLoading={loading} />
      <Breadcrumb
        title='New adding admin'
        textActive='New'
        items={[{ title: 'Admins' }]}
      />
      <div className='card rounded-1 mb-4 p-3'>
        <form onSubmit={formik.handleSubmit}>
          <div className='row'>
            <div className='col-md-6'>
              <div className='form-group'>
                <label htmlFor='name' className='text-muted'>
                  Enter your name <span className='required'>*</span>
                </label>
                <input
                  className='form-control'
                  name='name'
                  id='name'
                  inputMode='text'
                  type='text'
                  {...formik.getFieldProps('name')}
                  placeholder='John Due'
                />
                {formik.touched.name && formik.errors.name ? (
                  <div className='text-error'>{formik.errors.name}</div>
                ) : null}
              </div>
            </div>
            <div className='col-md-6'>
              <div className='form-group'>
                <label htmlFor='email' className='text-muted'>
                  Enter your email <span className='required'>*</span>
                </label>
                <input
                  className='form-control'
                  name='email'
                  id='email'
                  inputMode='email'
                  type='email'
                  placeholder='example@mail.com'
                  {...formik.getFieldProps('email')}
                />
                {formik.touched.email && formik.errors.email ? (
                  <div className='text-error'>{formik.errors.email}</div>
                ) : null}
              </div>
            </div>
            <div className='col-md-6'>
              <div className='form-group'>
                <label htmlFor='phone' className='text-muted'>
                  Enter your phone <span className='required'>*</span>
                </label>
                <input
                  className='form-control'
                  name='phone'
                  id='phone'
                  inputMode='tel'
                  type='tel'
                  placeholder='249123456789'
                  {...formik.getFieldProps('phone')}
                  onInput={checkValidationPhone}
                />
                {formik.touched.phone && formik.errors.phone ? (
                  <div className='text-error'>{formik.errors.phone}</div>
                ) : null}
              </div>
            </div>
            <div className='col-md-6'>
              <div className='form-group'>
                <label htmlFor='role' className='text-muted'>
                  Select your role admin <span className='required'>*</span>
                </label>
                <select
                  name='role'
                  id='role'
                  {...formik.getFieldProps('role')}
                  className='form-control'
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                >
                  <option value='DEFAULT' disabled>
                    Select your role admin
                  </option>
                  <option value='super'>super</option>
                  <option value='admin'>admin</option>
                </select>
                {formik.touched.role && formik.errors.role ? (
                  <div className='text-error'>{formik.errors.role}</div>
                ) : null}{' '}
              </div>
            </div>
            <div className='col-md-6'>
              <div className='form-group'>
                <label htmlFor='password' className='text-muted'>
                  Enter your password <span className='required'>*</span>
                </label>
                <div className='input-group input-group-flat'>
                  <input
                    className='form-control'
                    name='password'
                    id='password'
                    type={`${isShowPassword ? 'text' : 'password'}`}
                    placeholder='**************'
                    {...formik.getFieldProps('password')}
                  />
                  <span
                    className='input-group-text'
                    style={{ cursor: 'pointer' }}
                    onClick={() =>
                      toggleShowingPassword(isShowPassword, setIsShowPassword)
                    }
                  >
                    {isShowPassword ? <IconEye /> : <IconEyeOff />}
                  </span>
                </div>
                {formik.touched.password && formik.errors.password ? (
                  <div className='text-error'>{formik.errors.password}</div>
                ) : null}
              </div>
            </div>
            <div className='col-md-6'>
              <div className='form-group'>
                <label htmlFor='passwordConfirm' className='text-muted'>
                  Enter your confirm password{' '}
                  <span className='required'>*</span>
                </label>
                <div className='input-group input-group-flat'>
                  <input
                    className='form-control'
                    name='passwordConfirm'
                    id='passwordConfirm'
                    type={`${isShowPasswordConfirm ? 'text' : 'password'}`}
                    placeholder='************'
                    {...formik.getFieldProps('passwordConfirm')}
                  />
                  <span
                    className='input-group-text'
                    style={{ cursor: 'pointer' }}
                    onClick={() =>
                      toggleShowingPassword(
                        isShowPasswordConfirm,
                        setIsShowPasswordConfirm
                      )
                    }
                  >
                    {isShowPasswordConfirm ? <IconEye /> : <IconEyeOff />}
                  </span>
                </div>
                {formik.touched.passwordConfirm &&
                formik.errors.passwordConfirm ? (
                  <div className='text-error'>
                    {formik.errors.passwordConfirm}
                  </div>
                ) : null}
              </div>
            </div>
            <div className='col-md-12 mt-3 text-center'>
              <button
                className='btn btn-primary btn-user btn-inline'
                type='submit'
              >
                <FaLocationArrow style={{ marginRight: '.5rem' }} /> New Admin
              </button>
            </div>
          </div>
        </form>
      </div>
    </>
  );
}
